



import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import QRCode from 'qrcode';

@Component
export default class QrCodeComponent extends Vue {

    @Ref()
    canvas!: HTMLCanvasElement;

    @Prop({ required: true })
    private text!: string;

    @Prop({ default: 'primary' })
    private background!: string;

    @Watch('text')
    private async onTextChange(val: string) {
        await this.generateQrCode(val);
    }

    private generateQrCode(text: string) {
        return QRCode.toCanvas(this.canvas, text, { color: { light: this.background }, width: 120, margin: 2 });
    }

    private async mounted() {
        await this.generateQrCode(this.text);
    }

}
